import api from '@/services/api';
import { make } from 'vuex-pathify';
import { sortObjectsByAttribute } from '@/assets/js/utility';

const state = {
  dashboards: [],
};

const mutations = {
  ...make.mutations(state),
};

const actions = {
  async getDashboards({ commit, rootState }) {
    const r = await api.get('v2/dashboards');
    const dashboards = Object.entries(
      (r.data.data ?? []).reduce((acc, item) => {
        const isOwner = rootState.users.currentUser.id === item.owner_id;
        const attr = item.predefined ? 'predefined' : isOwner ? 'owner' : 'shared';
        return { ...acc, [attr]: [...(acc[attr] ?? []), item] };
      }, {})
    ).reduce(
      (acc, [key, value]) => ({
        ...acc,
        [key]: sortObjectsByAttribute(value, 'name'),
      }),
      {}
    );
    commit('SET_DASHBOARDS', dashboards);
  },
  async postDashboard({ dispatch }, payload) {
    await api.post('v2/dashboards', payload);
    await dispatch('getDashboards');
  },
  async putDashboard({ dispatch }, { id, payload }) {
    await api.put(`v2/dashboards/${id}`, payload);
    await dispatch('getDashboards');
  },
  async deleteDashboard({ dispatch }, id) {
    await api.delete(`v2/dashboards/${id}`);
    await dispatch('getDashboards');
  },
  async predefineDashboard({ dispatch }, { id, value = false }) {
    await api.post(`v2/dashboards/${id}/predefined/${value ? 'set' : 'unset'}`);
    await dispatch('getDashboards');
  },
  async getDashboardSharedUsers(store, id) {
    const r = await api.get(`v2/dashboards/${id}/shared_to`);
    return r.data.data.map(data => data.id);
  },
  async shareDashboard(store, data) {
    const { id, usersIds, value } = data;
    await api.post(`v2/dashboards/${id}/${value ? 'share' : 'unshare'}`, { user_ids: usersIds });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
